/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ---------------------------------------------------------------------------
   Price-range banner -- specific product pages only, scoped by URL so it
   never touches any other page or product. Injected via JS (instead of
   editing the large shared product-template-help-2027.liquid section) to
   keep this a small, self-contained, easy-to-remove change.
--------------------------------------------------------------------------- */
(function () {
  var BANNERS = {
    '/products/iphone-screen-replacement-cost': {
      amount: '$129 &ndash; $699',
      note: 'Compatible parts cost less, while genuine Apple parts and newer iPhone models cost more. Get a free quote before any repair begins.'
    },
    '/products/macbook-screen-replacement': {
      amount: '$299 &ndash; $950',
      note: 'Compatible parts cost less, while genuine Apple parts and newer MacBook Pro models cost more. Get a free quote before any repair begins.'
    },
    '/products/mac-repairs-macbook-repairs-battery-replacement': {
      amount: '$149 &ndash; $430',
      note: 'Compatible parts cost less, while genuine Apple parts and newer MacBook Pro models cost more. Get a free quote before any repair begins.'
    }
  };

  var config = (window.ubkPriceRangeMeta && window.ubkPriceRangeMeta.amount) ? window.ubkPriceRangeMeta : BANNERS[window.location.pathname];
  if (!config) return;

  function addPriceRangeBanner() {
    if (document.querySelector('.ubk-price-range')) return;

    var tagline = document.querySelector('.ac-prrt .short-metafield-csfd-27') || document.querySelector('.ac-prrt');
    if (!tagline) return;

    var style = document.createElement('style');
    style.textContent =
      'html body .ubk-price-range{display:block;margin:10px 0 0;padding:8px 12px;background:rgba(230,0,18,.08);border:1px solid rgba(230,0,18,.35);border-radius:8px;}' +
      'html body .ubk-price-range__amount{display:block;font-size:16px;font-weight:800;color:#fff;letter-spacing:-0.01em;line-height:1.2;}' +
      'html body .ubk-price-range__note{display:block;margin-top:2px;font-size:10.5px;font-weight:500;line-height:1.3;color:rgba(255,255,255,.6);}' +
      '@media (max-width:480px){html body .ubk-price-range{padding:7px 10px}html body .ubk-price-range__amount{font-size:15px}html body .ubk-price-range__note{font-size:10px}}';
    document.head.appendChild(style);

    var banner = document.createElement('div');
    banner.className = 'ubk-price-range';
    banner.innerHTML =
      '<span class="ubk-price-range__amount">' + config.amount + '</span>' +
      '<span class="ubk-price-range__note">' + config.note + '</span>';

    tagline.insertAdjacentElement('afterend', banner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addPriceRangeBanner);
  } else {
    addPriceRangeBanner();
  }
})();
